<div *ngIf="showBadge">
  <span class="badge badge-pill" [ngClass]="badgeClasses">
    <div>
      <span class="up-me">
        {{ isPublished ? i18n.Core_withPublished : i18n.SkillStd_Unpublished }}
      </span>
    </div>
  </span>
</div>
